/*!
 * PiercingXXL – Größen-Messassistent · Shopify-Konfigurator-Integration (PL)
 * Liest die messbaren Produktoptionen (select[name="options[..]"]), blendet einen
 * "Größe messen"-Button ein, öffnet das Tool als 1:1-Vollbild-Overlay (same-origin
 * Shopify-Page /pages/rozmiar?embed=1) und wählt nach dem Messen die passende
 * Option vor (select.value + change → Stiletto/ProductForm schaltet die Variante).
 */
(function () {
  "use strict";
  if (window.__pxxlSizeInit) return; window.__pxxlSizeInit = true;

  var LANGS = ['de', 'en', 'pl', 'es', 'fr', 'it'];
  var LANG = (document.documentElement.lang || 'pl').slice(0, 2).toLowerCase();
  if (LANGS.indexOf(LANG) < 0) LANG = 'pl';

  var TOOL_URL = '/pages/rozmiar';           // same-origin Shopify-Page (layout none)
  var RATGEBER_URL = '/collections/rozmiary-piercingu';   // Desktop-Ziel: Ratgeber-Collection
  var BTN = {                                 // Mobile: Trigger-/Tool-Button
    de: 'Richtige Größe auswählen', en: 'Choose the right size',
    pl: 'Wybierz właściwy rozmiar', es: 'Elige la talla correcta',
    fr: 'Choisir la bonne taille', it: 'Scegli la taglia giusta'
  };
  var LINK = {                                // Desktop: Trigger-Label
    de: 'Piercing messen?', en: 'How to measure?', pl: 'Jak mierzyć piercing?',
    es: '¿Cómo medir?', fr: 'Comment mesurer ?', it: 'Come misurare?'
  };
  // Desktop-Inline-Popup (QR zum Handy-Messen + Schablone/Ratgeber)
  var G_INTRO = {
    de: 'Am genauesten misst du mit einem Messschieber – siehe Erklärbild. Alternativ: Schablone ausdrucken, Ratgeber öffnen oder am Handy messen.',
    en: 'A caliper is the most accurate – see the diagram. Alternatively: print the template, open the guide or measure on your phone.',
    pl: 'Najdokładniej zmierzysz suwmiarką – zobacz schemat. Alternatywnie: wydrukuj szablon, otwórz poradnik lub zmierz telefonem.',
    es: 'Lo más preciso es un calibre – mira el esquema. Alternativas: imprimir la plantilla, abrir la guía o medir con el móvil.',
    fr: 'Le plus précis : un pied à coulisse – voir le schéma. Sinon : imprimer le gabarit, ouvrir le guide ou mesurer au téléphone.',
    it: 'Il più preciso è un calibro – vedi lo schema. In alternativa: stampa la sagoma, apri la guida o misura col telefono.'
  };
  var G_SCAN = {
    de: 'Scannen & am Handy messen', en: 'Scan & measure on your phone', pl: 'Zeskanuj i zmierz telefonem',
    es: 'Escanea y mide con el móvil', fr: 'Scanne et mesure au téléphone', it: 'Scansiona e misura col telefono'
  };
  // Erklärtext über dem Handy-Mess-Block (Desktop: QR · Mobile: Tool-Button)
  var G_LEAD = {
    de: 'Kein Messschieber zur Hand? Miss am Handydisplay – scanne den QR-Code:',
    en: 'No caliper at hand? Measure on your phone – scan the QR code:',
    pl: 'Nie masz suwmiarki? Zmierz na telefonie – zeskanuj kod QR:',
    es: '¿Sin calibre a mano? Mide con el móvil: escanea el código QR:',
    fr: 'Pas de pied à coulisse ? Mesure au téléphone – scanne le code QR :',
    it: 'Niente calibro a portata di mano? Misura col telefono – scansiona il codice QR:'
  };
  var G_LEAD_M = {
    de: 'Kein Messschieber zur Hand? Miss direkt auf dem Handydisplay:',
    en: 'No caliper at hand? Measure right on your phone screen:',
    pl: 'Nie masz suwmiarki? Zmierz bezpośrednio na ekranie telefonu:',
    es: '¿Sin calibre a mano? Mide directamente en la pantalla del móvil:',
    fr: 'Pas de pied à coulisse ? Mesure directement sur l\'écran du téléphone :',
    it: 'Niente calibro a portata di mano? Misura direttamente sullo schermo del telefono:'
  };
  // Mobile: Intro ohne QR-Bezug (das Tool öffnet direkt per Button)
  var G_INTRO_M = {
    de: 'So wird gemessen – am genauesten mit dem Messschieber (siehe Bild). Darunter die üblichen Standardgrößen.',
    en: 'How to measure – a caliper is the most accurate (see diagram). Below: common standard sizes.',
    pl: 'Tak się mierzy – najdokładniej suwmiarką (zobacz schemat). Poniżej standardowe rozmiary.',
    es: 'Así se mide – lo más preciso es un calibre (ver esquema). Debajo, las tallas estándar.',
    fr: 'Voici comment mesurer – le plus précis est le pied à coulisse (voir schéma). Ci-dessous : les tailles standard.',
    it: 'Ecco come misurare – il più preciso è il calibro (vedi schema). Sotto: le misure standard.'
  };
  var G_CLOSE = { de: 'Schließen', en: 'Close', pl: 'Zamknij', es: 'Cerrar', fr: 'Fermer', it: 'Chiudi' };
  var G_CTA = {
    de: 'Zum vollständigen Ratgeber', en: 'Open the full guide', pl: 'Otwórz pełny poradnik',
    es: 'Abrir la guía completa', fr: 'Ouvrir le guide complet', it: 'Apri la guida completa'
  };
  var PDF_LABEL = {
    de: 'Mess-Schablone (PDF)', en: 'Printable template (PDF)', pl: 'Szablon do druku (PDF)',
    es: 'Plantilla para imprimir (PDF)', fr: 'Gabarit à imprimer (PDF)', it: 'Sagoma da stampare (PDF)'
  };
  var MEAS = {
    gauge:    { de: 'Stärke', en: 'Thickness', pl: 'Grubość', es: 'Grosor', fr: 'Épaisseur', it: 'Spessore' },
    length:   { de: 'Länge', en: 'Length', pl: 'Długość', es: 'Longitud', fr: 'Longueur', it: 'Lunghezza' },
    diameter: { de: 'Durchmesser', en: 'Diameter', pl: 'Średnica', es: 'Diámetro', fr: 'Diamètre', it: 'Diametro' },
    ball:     { de: 'Kugel', en: 'Ball', pl: 'Kulka', es: 'Bola', fr: 'Bille', it: 'Pallina' }
  };
  var IMGBASE = 'https://cdn.shopify.com/s/files/1/0785/8565/9722/files/';
  var PDF_URL = IMGBASE + 'size-pl.pdf';
  function calImg(g) {
    if (g.type === 'gauge') return 'cal-thickness.png';
    if (g.type === 'length') return 'cal-length.png';
    if (g.type === 'ball') return 'cal-ball.png';
    return g.outer ? 'cal-plug.png' : 'cal-diameter.png';
  }
  function L(o) { return o[LANG] || o.en; }

  /* GA-/GTM-Tracking: Events landen im gemeinsamen window.dataLayer (server-side
     GTM via smu.piercing-xxl.net / load.lord.*). In GTM einen Custom-Event-Trigger
     auf "pxxl_size_tool" anlegen und an GA4 weiterreichen; mit "pxxl_action"
     unterscheiden (open_popup | open_pdf | open_guide | select_spot | open_tool |
     size_applied | tool_cancel | button_shown). Reine dataLayer-Pushes – kein
     direkter GA-Aufruf, Consent regelt GTM. */
  function track(action, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      var p = { event: 'pxxl_size_tool', pxxl_action: action, pxxl_lang: LANG, pxxl_device: isMobile() ? 'mobile' : 'desktop' };
      if (params) { for (var k in params) { if (Object.prototype.hasOwnProperty.call(params, k)) p[k] = params[k]; } }
      window.dataLayer.push(p);
    } catch (e) {}
  }

  /* Produkt-Metafelder: das Snippet product-block-variant-picker.liquid gibt
     custom.typeforcategories + custom.piercingtype (data-pxxl-type) und
     custom.search_bodypart (data-pxxl-bodyparts) am Mount-Div aus. Die Werte
     werden nur per Substring gematcht – Format-Altlasten im PIM sind egal. */
  function mountData(attr) {
    var el = document.getElementById('pxxl-size-mount');
    return ((el && el.getAttribute(attr)) || '').toLowerCase();
  }
  // Schmucktyp → Mess-Diagramm aus dem Ratgeber (measure-diagram-pl-*.png)
  var DIAGRAM_CAPTION = {
    barbell:   { de: 'Barbell (gerader Stab)', en: 'Barbell', pl: 'Barbell', es: 'Barbell', fr: 'Barbell', it: 'Barbell' },
    banana:    { de: 'Banane (gebogener Stab)', en: 'Curved barbell', pl: 'Banan (sztanga wygięta)', es: 'Barra curvada', fr: 'Barre courbée', it: 'Barra curva' },
    labret:    { de: 'Labret', en: 'Labret', pl: 'Labret', es: 'Labret', fr: 'Labret', it: 'Labret' },
    bcr:       { de: 'Ring (BCR)', en: 'Ring (BCR)', pl: 'Kółko BCR', es: 'Aro (BCR)', fr: 'Anneau (BCR)', it: 'Anello (BCR)' },
    horseshoe: { de: 'Hufeisen / Circular', en: 'Horseshoe / circular', pl: 'Podkowa / circular', es: 'Herradura / circular', fr: 'Fer à cheval / circulaire', it: 'Ferro di cavallo / circular' },
    plug:      { de: 'Plug', en: 'Plug', pl: 'Plug', es: 'Plug', fr: 'Plug', it: 'Plug' },
    tunnel:    { de: 'Tunnel', en: 'Tunnel', pl: 'Tunel', es: 'Túnel', fr: 'Tunnel', it: 'Tunnel' },
    ball:      { de: 'Kugel / Aufsatz', en: 'Ball / attachment', pl: 'Kulka / nakładka', es: 'Bola / accesorio', fr: 'Bille / embout', it: 'Pallina / accessorio' },
    nose:      { de: 'Nasenstecker', en: 'Nose stud', pl: 'Kolczyk do nosa', es: 'Piercing de nariz', fr: 'Piercing de nez', it: 'Piercing al naso' }
  };
  function detectDiagram() {
    var s = mountData('data-pxxl-type');
    if (!s) return null;
    if (/fake/.test(s)) return null;                         // Fake-/Klemmschmuck: Piercing-Messanleitung passt nicht
    if (/nose/.test(s)) return 'nose';                       // Nose Stud/Screw/L-Form (Nasenringe heißen "Nostril" → bcr)
    if (/curved|banana|eyebrow/.test(s)) return 'banana';
    if (/barbell|nipple piercing|tongue piercing/.test(s)) return 'barbell';
    if (/labret/.test(s)) return 'labret';
    if (/horseshoe/.test(s)) return 'horseshoe';
    if (/tunnel/.test(s)) return 'tunnel';
    if (/plug|expander/.test(s)) return 'plug';
    if (/captive|cbr|clicker|segmentring|piercing ring|hoop|creole|bendable|septum/.test(s)) return 'bcr';
    if (/parts\s*-\s*(top|ball)/.test(s)) return 'ball';
    return null;                                             // unbekannt → generische cal-*-Bilder
  }
  // Übliche Standardgrößen je Piercingstelle (Werte/Bilder aus dem Ratgeber „Rozmiary piercingu“)
  var SEL_TITLE = {
    de: 'Piercingstelle & übliche Standardgröße', en: 'Piercing spot & common standard size',
    pl: 'Miejsce piercingu i standardowy rozmiar', es: 'Zona del piercing y talla estándar',
    fr: 'Emplacement du piercing et taille standard', it: 'Punto del piercing e misura standard'
  };
  var SPOTS = [
    { key: 'ear', img: 'piercing-size-ear-v2.png', g: '1,2 mm', l: '8 mm', d: '8–10 mm',
      t: { de: 'Ohr (Läppchen / Helix / Tragus)', en: 'Ear (lobe / helix / tragus)', pl: 'Ucho (płatek / helix / tragus)', es: 'Oreja (lóbulo / hélix / tragus)', fr: 'Oreille (lobe / hélix / tragus)', it: 'Orecchio (lobo / helix / tragus)' } },
    { key: 'daith', img: 'piercing-size-daith-v2.png', g: '1,6 mm', l: '10 mm', d: '10–12 mm',
      t: { de: 'Daith', en: 'Daith', pl: 'Daith', es: 'Daith', fr: 'Daith', it: 'Daith' } },
    { key: 'conch', img: 'piercing-size-conch-v2.png', g: '1,6 mm', l: '10 mm', d: '10–12 mm',
      t: { de: 'Conch', en: 'Conch', pl: 'Conch', es: 'Conch', fr: 'Conch', it: 'Conch' } },
    { key: 'industrial', img: 'piercing-size-industrial-v3.png', g: '1,6 mm', l: '30–50 mm', d: null,
      t: { de: 'Industrial', en: 'Industrial', pl: 'Industrial', es: 'Industrial', fr: 'Industrial', it: 'Industrial' } },
    { key: 'nose', img: 'piercing-size-nose-v3.png', g: '1,0–1,2 mm', l: '6–8 mm', d: '6–11 mm',
      t: { de: 'Nase', en: 'Nose', pl: 'Nos', es: 'Nariz', fr: 'Nez', it: 'Naso' } },
    { key: 'lip', img: 'piercing-size-lip-v2.png', g: '1,2 mm', l: '8 mm', d: '6–8 mm',
      t: { de: 'Lippe', en: 'Lip', pl: 'Usta / warga', es: 'Labio', fr: 'Lèvre', it: 'Labbro' } },
    { key: 'eyebrow', img: 'piercing-size-eyebrow-v3.png', g: '1,2 mm', l: '8–10 mm', d: '8–10 mm',
      t: { de: 'Augenbraue', en: 'Eyebrow', pl: 'Brew', es: 'Ceja', fr: 'Sourcil', it: 'Sopracciglio' } },
    { key: 'belly', img: 'piercing-size-belly-v3.png', g: '1,6 mm', l: '10 mm', d: '10 mm',
      t: { de: 'Bauchnabel', en: 'Belly button', pl: 'Pępek', es: 'Ombligo', fr: 'Nombril', it: 'Ombelico' } },
    { key: 'tongue', img: 'piercing-size-tongue-v2.png', g: '1,6 mm', l: '16 mm', d: null,
      t: { de: 'Zunge', en: 'Tongue', pl: 'Język', es: 'Lengua', fr: 'Langue', it: 'Lingua' } },
    { key: 'nipple', img: 'size-nipple-lemon-v2.png', g: '1,6 mm', l: '10–12 mm', d: '10–12 mm',
      t: { de: 'Brustwarze', en: 'Nipple', pl: 'Sutek', es: 'Pezón', fr: 'Téton', it: 'Capezzolo' } },
    { key: 'intimate', img: 'size-intimate-orchid.png', g: '1,6–2,6 mm', l: '10–18 mm', d: '10 mm',
      t: { de: 'Intim', en: 'Intimate', pl: 'Intymne', es: 'Íntimo', fr: 'Intime', it: 'Intimo' } }
  ];
  // custom.search_bodypart (PL-Werte) → Stellen; „Ucho“ zusätzlich mit
  // Daith/Conch, Industrial nur wenn der Schmucktyp dazu passt
  function spotsForProduct() {
    var bp = mountData('data-pxxl-bodyparts');
    // Keine Piercing-Standardgrößen für: Fakes/Ear Cuffs (geklemmt), Dermals
    // (eigene Maße), Mode-Ohrschmuck. "stud"/"earring" nur als Exakt-Wert in
    // Anführungszeichen – "Nose Stud"/"Bendable earring" bleiben unberührt.
    if (!bp || /fake|dermal|ear cuff|ear crawler|hookring|"stud"|"earring"/.test(mountData('data-pxxl-type'))) return [];
    var keys = [];
    if (/ucho/.test(bp)) keys.push('ear', 'daith', 'conch');
    if (/industrial/.test(mountData('data-pxxl-type'))) keys.push('industrial');
    if (/nos/.test(bp)) keys.push('nose');
    if (/usta|warg/.test(bp)) keys.push('lip');
    if (/brew/.test(bp)) keys.push('eyebrow');
    if (/p[ęe]pek/.test(bp)) keys.push('belly');
    if (/j[ęe]zyk/.test(bp)) keys.push('tongue');
    if (/sutek/.test(bp)) keys.push('nipple');
    if (/intym/.test(bp)) keys.push('intimate');
    return SPOTS.filter(function (s) { return keys.indexOf(s.key) >= 0; });
  }

  function isMobile() {
    var ua = navigator.userAgent || '';
    if (/Android|iPhone|iPod|Windows Phone|Mobile|BlackBerry|Opera Mini/i.test(ua)) return true;
    var coarse = window.matchMedia && matchMedia('(any-pointer:coarse)').matches;
    var touch = (navigator.maxTouchPoints || 0) > 0 || 'ontouchstart' in window;
    return !!(coarse && touch);
  }

  function classify(name) {
    var s = (name || '').toLowerCase();
    if (/grub|stärk|stark/.test(s)) return 'gauge';
    if (/läng|lang|długo|dlugo/.test(s)) return 'length';
    if (/kugel|kulk|disc|dysk|spitze|końców|koncow|kristall|kryszta/.test(s)) return 'ball';
    if (/außendurch|aussendurch|zewn/.test(s)) return 'diameter_out';
    if (/durchmess|średnic|srednic|innendurch/.test(s)) return 'diameter';
    if (/ringgr|^\s*rozmiar\s*$/.test(s)) return 'diameter';
    return null;
  }
  var RANGE = { gauge: [0.6, 6.5], length: [3, 42], diameter: [4, 26], diameter_out: [4, 26], ball: [2, 12] };

  function parseMM(label) {
    if (label == null) return null;
    var s = ('' + label).toLowerCase().replace(',', '.');
    var cm = /\bcm\b/.test(s);
    var m = s.match(/(\d+(?:\.\d+)?)/);
    if (!m) return null;
    var n = parseFloat(m[1]); if (cm) n *= 10; return n;
  }
  function optName(sel) { var m = (sel.name || '').match(/options\[(.+)\]/); return m ? m[1] : null; }

  function getGroups() {
    var out = [];
    var selects = document.querySelectorAll('select[name^="options["]');
    Array.prototype.forEach.call(selects, function (sel) {
      var name = optName(sel); if (!name) return;
      var type = classify(name); if (!type) return;
      var realType = (type === 'diameter_out') ? 'diameter' : type;
      var opts = [];
      Array.prototype.forEach.call(sel.options, function (o) {
        if (o.disabled) return;
        opts.push({ optionId: o.value, label: (o.textContent || o.value).trim(), mm: parseMM(o.value || o.textContent) });
      });
      var nums = opts.filter(function (o) { return o.mm != null; });
      var r = RANGE[type];
      var inRange = nums.filter(function (o) { return o.mm >= r[0] && o.mm <= r[1]; });
      if (opts.length && nums.length >= opts.length * 0.6 && inRange.length >= 1) {
        out.push({ groupId: name, type: realType, outer: type === 'diameter_out', options: nums });
      }
    });
    return out;
  }

  function applySelections(sels) {
    sels.forEach(function (s) {
      if (s.optionId == null) return;
      // passenden <select name="options[Name]"> finden (ohne Selector-Escaping)
      var selects = document.querySelectorAll('select[name^="options["]');
      Array.prototype.forEach.call(selects, function (sel) {
        if (optName(sel) !== s.groupId) return;
        if (sel.value !== s.optionId) {
          sel.value = s.optionId;
          sel.dispatchEvent(new Event('input', { bubbles: true }));
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      // sichtbaren Button (Swatch/Chip) ebenfalls spiegeln, falls vorhanden
      var btns = document.querySelectorAll('[data-option-buttons] button[data-option-value]');
      Array.prototype.forEach.call(btns, function (b) {
        if (b.getAttribute('data-option-value') === s.optionId && !/\bselected\b/.test(b.className)) {
          try { b.click(); } catch (e) {}
        }
      });
    });
  }

  // iframe ist site-weit per CSP (frame-ancestors 'none') geblockt → Tool in
  // eigenem Tab öffnen, Ergebnis via window.opener-postMessage zurückgeben.
  function openTool(groups) {
    track('open_tool', { pxxl_jewelry_type: detectDiagram() || 'generic', pxxl_groups: (groups || []).length });
    var pv = (location.search.match(/[?&]preview_theme_id=(\d+)/) || [])[1];
    var url = TOOL_URL + '?embed=1&lang=' + encodeURIComponent(LANG) + (pv ? '&preview_theme_id=' + pv : '');
    var w = window.open(url, 'pxxlsize');
    if (!w) { alert('Bitte Pop-ups für diese Seite erlauben, um die Größe zu messen.'); return; }
    try { w.focus(); } catch (e) {}

    function onMsg(e) {
      var d = e.data; if (!d || d.src !== 'pxxlsize') return;
      if (d.type === 'ready') {
        try { w.postMessage({ type: 'pxxlsize-init', lang: LANG, groups: groups }, '*'); } catch (er) {}
      } else if (d.type === 'track') {
        track(d.action, d.data || {});
      } else if (d.type === 'result') {
        window.removeEventListener('message', onMsg);
        var sels = d.selections || [];
        track('size_applied', {
          pxxl_jewelry_type: detectDiagram() || 'generic',
          pxxl_count: sels.length,
          pxxl_sizes: sels.map(function (s) { return s.type + ':' + s.label; }).join(', ')
        });
        applySelections(sels);
        try { w.close(); } catch (er) {}
        try { window.focus(); } catch (er) {}
      } else if (d.type === 'cancel') {
        track('tool_cancel');
        window.removeEventListener('message', onMsg);
        try { w.close(); } catch (er) {}
        try { window.focus(); } catch (er) {}
      }
    }
    window.addEventListener('message', onMsg);
  }

  // Inline-Popup (kein iframe → CSP-sicher): Messgrafik → Standardgrößen →
  // Desktop: QR zum Handy-Messen + PDF · Mobile: Button öffnet das Mess-Tool
  function openGuideModal() {
    var mob = isMobile();
    var ov = document.createElement('div');
    ov.style.cssText = 'position:fixed;inset:0;z-index:2147483000;background:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;padding:16px';
    var card = document.createElement('div');
    card.setAttribute('role', 'dialog');
    card.style.cssText = 'position:relative;background:#fff;border-radius:14px;max-width:440px;width:100%;max-height:92vh;overflow:auto;padding:24px;box-shadow:0 12px 44px rgba(0,0,0,.32);font:15px/1.5 -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;color:#222';
    // Mess-Grafik: passendes Ratgeber-Diagramm zum Schmucktyp (aus Metafeldern),
    // sonst Fallback auf die generischen Mess-Bilder je messbarer Option
    var groups = getGroups();
    var diag = detectDiagram();
    var imgs;
    if (diag) {
      imgs = '<figure style="margin:0 auto;max-width:230px;text-align:center">' +
        '<img src="' + IMGBASE + 'measure-diagram-pl-' + diag + '.png" alt="" loading="lazy" style="width:100%;object-fit:contain;border:1px solid #eee;border-radius:10px;background:#fff" onerror="this.parentNode.style.display=\'none\'">' +
        '<figcaption style="font-size:12px;color:#666;margin-top:4px">' + L(DIAGRAM_CAPTION[diag]) + '</figcaption></figure>';
    } else {
      imgs = groups.map(function (g) {
        return '<figure style="margin:0;flex:1 1 110px;min-width:110px;max-width:160px;text-align:center">' +
          '<img src="' + IMGBASE + calImg(g) + '" alt="" loading="lazy" style="width:100%;max-height:120px;object-fit:contain" onerror="this.style.display=\'none\'">' +
          '<figcaption style="font-size:12px;color:#666;margin-top:4px">' + L(MEAS[g.type] || MEAS.length) + '</figcaption></figure>';
      }).join('');
    }
    // Auswahlbox: passende Piercingstellen (Metafeld) mit Standardgröße aus dem Ratgeber
    var spots = spotsForProduct();
    track('open_popup', { pxxl_jewelry_type: diag || 'generic', pxxl_has_options: groups.length > 0, pxxl_spots: spots.length });
    var spotHtml = '';
    if (spots.length) {
      spotHtml = '<div style="margin:0 0 16px;padding:12px;border:1px solid #eee;border-radius:10px;background:#fafafa">' +
        '<label for="pxxl-spotsel" style="display:block;font-size:13px;font-weight:600;margin:0 0 6px">' + L(SEL_TITLE) + '</label>' +
        // appearance:none + eigenes Chevron-SVG: manche Theme-Resets entfernen den
        // nativen Select-Pfeil, dann wäre die Liste nicht als Dropdown erkennbar
        '<select id="pxxl-spotsel" style="width:100%;padding:8px 36px 8px 10px;border:1px solid #ccc;border-radius:8px;font-size:14px;color:#222;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:#fff url(data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20width%3D%2712%27%20height%3D%278%27%3E%3Cpath%20d%3D%27M1%201l5%205%205-5%27%20fill%3D%27none%27%20stroke%3D%27%23666%27%20stroke-width%3D%272%27%20stroke-linecap%3D%27round%27%2F%3E%3C%2Fsvg%3E) no-repeat right 12px center">' +
        spots.map(function (s) { return '<option value="' + s.key + '">' + L(s.t) + '</option>'; }).join('') +
        '</select>' +
        '<div id="pxxl-spotinfo" style="display:flex;align-items:center;gap:12px;margin-top:10px"></div></div>';
    }
    // Desktop: QR-Code auf die aktuelle Produktseite → am Handy öffnen & messen
    var qrData = location.origin + location.pathname;
    var qrSrc = 'https://api.qrserver.com/v1/create-qr-code/?size=240x240&margin=8&data=' + encodeURIComponent(qrData);
    var qrHtml = '<p style="margin:0 0 10px;color:#444">' + L(G_LEAD) + '</p>' +
      '<figure id="pxxl-qrfig" style="margin:0 0 14px;text-align:center">' +
      '<img src="' + qrSrc + '" alt="QR" width="180" height="180" style="border:1px solid #eee;border-radius:10px;padding:6px;background:#fff" onerror="var f=document.getElementById(\'pxxl-qrfig\');if(f)f.style.display=\'none\'">' +
      '<figcaption style="font-size:12px;color:#666;margin-top:4px">' + L(G_SCAN) + '</figcaption></figure>';
    // Mobile: Button öffnet das Mess-Tool (eigener Tab, window.opener-postMessage)
    var toolHtml = '<p style="margin:0 0 10px;color:#444">' + L(G_LEAD_M) + '</p>' +
      '<button type="button" id="pxxl-opentool" style="display:flex;align-items:center;justify-content:center;gap:8px;width:100%;margin:0 0 4px;padding:13px 14px;border:0;border-radius:10px;background:#c19433;color:#fff;font-weight:700;font-size:15px;cursor:pointer">📏 ' + (BTN[LANG] || BTN.en) + '</button>';
    card.innerHTML =
      '<button type="button" aria-label="' + L(G_CLOSE) + '" data-close style="position:absolute;top:10px;right:12px;border:0;background:none;font-size:20px;line-height:1;color:#888;cursor:pointer">✕</button>' +
      '<h2 style="margin:0 0 .4em;font-size:19px">📏 ' + (LINK[LANG] || LINK.en) + '</h2>' +
      '<p style="margin:.2em 0 .8em;color:#444">' + L(mob ? G_INTRO_M : G_INTRO) + '</p>' +
      (imgs ? '<div style="display:flex;flex-wrap:wrap;gap:12px;justify-content:center;margin:0 0 16px">' + imgs + '</div>' : '') +
      // Desktop: PDF-Schablone über der Piercingstellen-Auswahl
      (mob ? '' : '<a href="' + PDF_URL + '" data-pxxl-pdf target="_blank" rel="noopener" style="display:flex;align-items:center;justify-content:center;gap:8px;margin:0 0 14px;padding:12px 14px;border-radius:10px;background:#c19433;color:#fff;font-weight:700;text-decoration:none">📄 ' + L(PDF_LABEL) + '</a>') +
      spotHtml +
      // ohne messbare Optionen gibt es nichts vorzuwählen → Tool-Button/QR
      // weglassen (Popup informiert dann nur über Maße und Standardgrößen)
      (mob ? (groups.length ? toolHtml : '') : (groups.length ? qrHtml : '')) +
      '<a href="' + RATGEBER_URL + '" data-pxxl-guide target="_blank" rel="noopener" style="display:block;text-align:center;margin:10px 0;color:#a87d20;font-weight:600;text-decoration:underline">' + L(G_CTA) + ' →</a>' +
      '<button type="button" data-close style="display:block;width:100%;margin-top:6px;padding:11px 14px;border:1px solid #ddd;border-radius:10px;background:#fff;color:#444;font-weight:600;cursor:pointer">' + L(G_CLOSE) + '</button>';
    ov.appendChild(card);
    document.body.appendChild(ov);
    // Tracking: PDF-Schablone bzw. vollständiger Ratgeber geöffnet
    var pdfA = card.querySelector('[data-pxxl-pdf]');
    if (pdfA) pdfA.addEventListener('click', function () { track('open_pdf'); });
    var guideA = card.querySelector('[data-pxxl-guide]');
    if (guideA) guideA.addEventListener('click', function () { track('open_guide'); });
    if (spots.length) { // Standardgröße zur gewählten Piercingstelle anzeigen
      var sel = card.querySelector('#pxxl-spotsel'), info = card.querySelector('#pxxl-spotinfo');
      var renderSpot = function () {
        var s = null;
        spots.forEach(function (x) { if (x.key === sel.value) s = x; });
        if (!s) return;
        var rows = '<span style="white-space:nowrap"><b>' + L(MEAS.gauge) + ':</b> ' + s.g + '</span>' +
          (s.l ? '<span style="white-space:nowrap"><b>' + L(MEAS.length) + ':</b> ' + s.l + '</span>' : '') +
          (s.d ? '<span style="white-space:nowrap"><b>' + L(MEAS.diameter) + ':</b> ' + s.d + '</span>' : '');
        info.innerHTML = '<img src="' + IMGBASE + s.img + '" alt="" width="64" height="64" loading="lazy" style="border-radius:8px;object-fit:cover;flex:0 0 auto" onerror="this.style.display=\'none\'">' +
          '<span style="font-size:13px;color:#444;display:flex;flex-wrap:wrap;gap:4px 12px">' + rows + '</span>';
      };
      sel.onchange = function () { renderSpot(); track('select_spot', { pxxl_spot: sel.value }); }; renderSpot();
    }
    if (mob) { // Mess-Tool aus dem Popup heraus öffnen (User-Geste bleibt erhalten)
      var tb = card.querySelector('#pxxl-opentool');
      if (tb) tb.onclick = function () { close(); openTool(getGroups()); };
    }
    var prev = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    function close() { if (ov.parentNode) ov.parentNode.removeChild(ov); document.documentElement.style.overflow = prev; document.removeEventListener('keydown', onKey); }
    function onKey(e) { if (e.key === 'Escape') close(); }
    ov.addEventListener('click', function (e) { if (e.target === ov || (e.target.getAttribute && e.target.getAttribute('data-close') !== null)) close(); });
    card.querySelector('[data-close]').onclick = close;
    document.addEventListener('keydown', onKey);
  }

  function injectButton(groups) {
    var mount = document.getElementById('pxxl-size-mount');
    if (!mount) {
      var anchor = document.querySelector('[data-product-option]');
      if (anchor && anchor.parentNode) { mount = document.createElement('div'); anchor.parentNode.appendChild(mount); }
    }
    if (!mount) return;
    if (isMobile()) {
      // Mobile: Mess-Button → Popup (Messgrafik + Standardgrößen), Tool von dort;
      // ohne messbare Optionen passt das "Wie messen?"-Label besser
      var lbl = groups.length ? BTN : LINK;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'pxxl-size-btn';
      b.style.cssText = 'display:flex;align-items:center;gap:8px;justify-content:center;width:100%;margin:10px 0;padding:12px 14px;border:1px solid #c19433;border-radius:10px;background:#fff;color:#a87d20;font-weight:700;cursor:pointer';
      b.innerHTML = '<span style="font-size:17px">📏</span><span>' + (lbl[LANG] || lbl.en) + '</span>';
      b.onclick = openGuideModal;
      mount.appendChild(b);
    } else {
      // Desktop: Button öffnet ein Inline-Popup (Mess-Anleitung + Ratgeber-Link)
      var b2 = document.createElement('button');
      b2.type = 'button'; b2.className = 'pxxl-size-btn';
      b2.style.cssText = 'display:flex;align-items:center;gap:8px;justify-content:center;width:100%;margin:10px 0;padding:12px 14px;border:1px solid #c19433;border-radius:10px;background:#fff;color:#a87d20;font-weight:700;cursor:pointer';
      b2.innerHTML = '<span style="font-size:17px">📏</span><span>' + (LINK[LANG] || LINK.en) + '</span>';
      b2.onclick = openGuideModal;
      mount.appendChild(b2);
    }
    track('button_shown', { pxxl_has_options: groups.length > 0, pxxl_jewelry_type: detectDiagram() || 'generic' });
  }

  function init() {
    var groups = getGroups();
    // Auch ohne messbare Optionen (Einheitsgröße: nur Color/Title/Material)
    // anzeigen, wenn das Produkt per Metafeld als Piercing erkennbar ist –
    // das Popup informiert dann über Mess-Diagramm und Standardgrößen
    if (groups.length || detectDiagram() || spotsForProduct().length) injectButton(groups);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
